module.exports = __webpack_public_path__ + "img/fake_im.fac97917.png";